export { TablerIconArrow } from "./TablerIconArrow";
